import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Swiper from 'swiper/dist/js/swiper.min.js'
import '../../assets/scripts/jquery.waypoints.min.js'
import '../../assets/scripts/jquery.countup.min.js'
// 产品轮播
var proswiper = new Swiper("#section3 .swiper_development .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 81,
    navigation: {
      nextEl: "#section3 .swiperbtn  .swiper_next",
      prevEl: "#section3 .swiperbtn .swiper_prev",
    },
    breakpoints: {
      1440: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 80,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });

  (function ($) {
    $.fn.numberRock = function (options) {
      var defaults = {
        lastNumber: 100,
        duration: 3000,
        easing: 'swing' 
      };
      var opts = $.extend({}, defaults, options);
  
      $(this).animate({
        num: "numberRock",
      }, {
        duration: opts.duration,
        easing: opts.easing,
        complete: function () {
          // console.log("success");
        },
        step: function (a, b) {
          $(this).html(parseInt(b.pos * opts.lastNumber));
        }
      });
    }
  })(jQuery);

$(document).ready(function(){
    var top=$(this).scrollTop();//当前窗口的滚动距离
    console.log(top);
    if(top>1900){
        $(".counter1").numberRock({
            lastNumber: $(".counter1").html()*1,
            duration: 2000,
            easing: 'swing',
          });
          $(".counter2").numberRock({
            lastNumber: $(".counter2").html()*1,
            duration: 2000,
            easing: 'swing',
          });
          $(".counter3").numberRock({
            lastNumber: $(".counter3").html()*1,
            duration: 2000,
            easing: 'swing',
          });
          $(".counter4").numberRock({
            lastNumber: $(".counter4").html()*1,
            duration: 2000,
            easing: 'swing',
          });
    }else{
        $('.counter').countUp();
    }
    // if($(window).width() > 1024){
    //     $(".counter1").numberRock({
    //         lastNumber: $(".counter1").html()*1,
    //         duration: 2000,
    //         easing: 'swing',
    //       });
    //       $(".counter2").numberRock({
    //         lastNumber: $(".counter2").html()*1,
    //         duration: 2000,
    //         easing: 'swing',
    //       });
    //       $(".counter3").numberRock({
    //         lastNumber: $(".counter3").html()*1,
    //         duration: 2000,
    //         easing: 'swing',
    //       });
    //       $(".counter4").numberRock({
    //         lastNumber: $(".counter4").html()*1,
    //         duration: 2000,
    //         easing: 'swing',
    //       });
    // }else{
    //     $('.counter').countUp();
    // }
  })